// extracted by mini-css-extract-plugin
module.exports = {"title":"e_W7","author":"e_X7","container":"e_Y7","image":"e_Z7","uiHolder":"e__7"};